import { useTranslation } from 'next-i18next';
import React from 'react';

import { useAnimation } from '@/hooks';
import { useAppDispatch } from '@/redux';

import { toggleTopChronoModal } from '@/redux/slices/gui.slice';

import TopChronoDateSelector from '@/components/checkout/shipMode/DeliverySelector/TopChronoDateSelector';
import FullScreenContainerV2 from '@/components/layout/modals/FullScreenContainerV2';

import styles from './TopChronoModal.module.scss';
import { ModalHeaderDsProps } from '@/components/layout/modals/ModalHeader.ds';
import { ModalFooterDsProps } from '@/components/layout/modals/ModalFooter.ds';
import { ANIMATION } from '@/constants/animation';
import { NS } from '@/constants';

const FORM_ID = 'timeslot';

type TopChronoModalProps = {
  onSelectedSlot: (slot) => void;
  isExproCheckout: boolean;
  isOpen?: boolean;
}

export const TopChronoModal = ({ onSelectedSlot, isExproCheckout, isOpen }: TopChronoModalProps): React.JSX.Element => {
  const { t } = useTranslation(NS.CHECKOUT);
  const dispatch = useAppDispatch();
  const { animationState: animation, handleCloseModal } = useAnimation({});

  const closeModal = () => {
    handleCloseModal();
    setTimeout(() => {
      dispatch(toggleTopChronoModal({ opened: false, shippingId: '' }));
    }, ANIMATION.DELAY);
  };

  const headlineProps = {
    onCloseClick: closeModal,
    title: t('shipMode.topChrono.chooseDateAndSlot')
  } as ModalHeaderDsProps;
  const footerProps = {
    confirm: {
      label: t('shipMode.topChrono.confirmSlot'),
      formId: FORM_ID
    }
  } as ModalFooterDsProps;

  return (
    <FullScreenContainerV2
      onClose={closeModal}
      overlay
      padding="md"
      classNames={{ container: styles.container }}
      animationClass={animation}
      designSystemHeader={headlineProps}
      designSystemFooter={footerProps}
      isOpen={isOpen}
    >
      <TopChronoDateSelector onSelectedSlot={onSelectedSlot} withPadding isExproCheckout={isExproCheckout} />
    </FullScreenContainerV2>
  );
};

export default TopChronoModal;
